import firebase from "firebase/app";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
// new code of stripe
import "firebase/functions";
import getStripe from './Stripe';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
var app;
if (!firebase.apps.length) {
  app = firebase.initializeApp(firebaseConfig);
}
// const app = firebase.initializeApp(firebaseConfig);
// var analytics = firebase.analytics();


// var analytics = firebase.analytics();

// DATABASE
var db = firebase.firestore();
// debugger;
// Get a reference to the storage service, which is used to create references in your storage bucket
var storage = firebase.storage();
const googleProvider = new firebase.auth.GoogleAuthProvider()
// Create a storage reference from our storage service
var storageRef = storage.ref();

// new code of stripe
// TODO need to change to exact price id
export async function createCheckoutSession(uid, billing_type) {
  let price = 'price_1JdX3tGisCHFeAQzZHW4L0st';
  if (billing_type === 'weekly') {
    price = 'price_1JdX3tGisCHFeAQzZHW4L0st';
  } else if (billing_type === 'monthly') {
    price = 'price_1JdX3tGisCHFeAQzZHW4L0st';
  } else {
    price = 'price_1JdX3tGisCHFeAQzZHW4L0st';
  }
  const checkoutSessionRef = await db
    .collection('users')
    .doc(uid)
    .collection('checkout_sessions')
    .add({
      price: price,
      // This can be removed if you don't want promo codes
      allow_promotion_codes: true,
      success_url: window.location.origin,
      cancel_url: window.location.origin
    });
  checkoutSessionRef.onSnapshot(async (snap) => {
    const { sessionId } = snap.data();
    if (sessionId) {
      const stripe = await getStripe();
      stripe.redirectToCheckout({ sessionId });
    }
  });
}

export const getStripeRole = () => {
  try {
    return firebase.auth().currentUser.getIdTokenResult(true).then(decodedToken => {
      return decodedToken.claims.stripeRole || 'free';
    }).catch(error => {
      return 'free';
    });
  } catch (error) {
    console.error();
    return new Promise(()=>'free');
  }
};

export const getStripeRole1 = async () => {
  // await firebase.auth().currentUser.getIdToken(true);
  // if (firebase.auth().currentUser === null) {
  //   return 'free';
  // }
  // firebase.auth().onAuthStateChanged((user) => {
  //   if (user) {
  //     // User is signed in, see docs for a list of available properties
  //     // https://firebase.google.com/docs/reference/js/firebase.User
  //     var uid = user.uid;
  //     // ...
  //   } else {
  //     // User is signed out
  //     // ...
  //   }
  // });
  try {
    // await firebase.auth().currentUser.getIdToken(true);
    const decodedToken = await firebase.auth().currentUser.getIdTokenResult();
    return decodedToken.claims.stripeRole || 'free';
  } catch (error) {
    console.error();
    return 'free';
  }
};


export async function goToBillingPortal() {
  const functionRef = app
    .functions('us-central1')
    .httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink')
  const { data } = await functionRef({
    returnUrl: `${window.location.origin}/profile`,
  })
  window.location.assign(data.url)
}
// new code of stripe

export { db, storage, storageRef, googleProvider };
export default firebase;